import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogConfiguration } from '@cupoui/shared/model/modal/modal-dialog-configuration';

@Component({
    selector: 'app-terms-of-use-modal',
    templateUrl: './terms-of-use-modal.component.html',
    styleUrls: ['./terms-of-use-modal.component.scss'],
    standalone: false
})
export class TermsOfUseModalComponent implements OnInit {
  modalDialogConfiguration: ModalDialogConfiguration;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.modalDialogConfiguration = new ModalDialogConfiguration({
      header: 'Terms of use',
      isCrossClose: false,
      isYes: true,
      yesLabel: 'Accept',
      isClose: false
    });
  }

  closeModalEvent(event: boolean): void {
    if (event) {
      localStorage.setItem('terms-of-use-accepted', 'true');
      this.activeModal.dismiss('closed');
    }
  }
}
